// src/hooks/useActivityLog.js
// React hook for easy activity logging

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import activityLogService, { ACTION_TYPES } from '../services/activityLogService';
import { useEquityManagerStore } from '../products/equityManager/state/equityManagerStore';

/**
 * Hook to automatically log page access in Equity module
 * Usage: useActivityLog('Shareholders') in a page component
 */
export const useActivityLog = (pageName, companyId = null) => {
  const location = useLocation();
  const { selectedCompany } = useEquityManagerStore();

  useEffect(() => {
    // Determine company ID
    const effectiveCompanyId = companyId || selectedCompany?.id || null;

    // Log page access
    activityLogService.logPageAccess(pageName, effectiveCompanyId).catch(err =>
      console.warn('Failed to log page access:', err)
    );
  }, [location.pathname, pageName, companyId, selectedCompany?.id]);
};

/**
 * Hook to log Dataroom project access
 */
export const useDataroomActivityLog = (projectId) => {
  const location = useLocation();

  useEffect(() => {
    if (projectId) {
      activityLogService.logDataroomActivity(
        projectId,
        ACTION_TYPES.PROJECT_ACCESSED,
        { path: location.pathname }
      ).catch(err =>
        console.warn('Failed to log project access:', err)
      );
    }
  }, [projectId, location.pathname]);
};

export default useActivityLog;
















